import msg from "components/string-table";
import { Section } from "main";

import styles from "./Feedback.module.css";

type Feedback = {
  content: string;
  schoolName: string;
};

export type FeedbackProps = {
  feedbacks?: Feedback[];
};

export function Feedback(props: FeedbackProps) {
  const { feedbacks } = props;

  return (
    <Section title={msg("SUB_PROFILE_FEEDBACK_FROM_SCHOOLS_HEADER")}>
      <div>
        {feedbacks && feedbacks.length > 0 ? (
          feedbacks.map((f, idx) => (
            <blockquote key={`${f.schoolName}-${idx}`} className={styles.quote}>
              <div className={styles.quoteContent}>
                <p style={{ margin: 0 }}>
                  <span>
                    <q>
                      <i>{f.content}</i>
                    </q>
                  </span>
                </p>
                <footer className={styles.schoolName}>{`- ${f.schoolName}`}</footer>
              </div>
            </blockquote>
          ))
        ) : (
          <span className={styles.noFeedback}>{msg("SUB_PROFILE_NO_INFORMATION")}</span>
        )}
      </div>
    </Section>
  );
}
